/*
*###############################################################################
*Module Name                   : VoucherRequestController.js                     #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Friday, October 1st 2021, 3:20:00 pm          #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

//Import react and bootstrap components
import React, { useState } from 'react'
import { CardText, Col, Row, Alert, Button } from 'reactstrap'
//Import Framework components
import DPTextBox from 'framework/components/DPTextBox'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
import DPTextBoxTow from 'framework/components/DPTextBoxTow'
import DPSearchBoxDynamicHeadOffice from 'framework/components/DPSearchBoxDynamicHeadOffice'
const VoucherRequestContent = ({
    Gen_DataSearch,
    AlertColor,
    AlertMsg,
    show,
    Gen_Code,
    Gen_Code_OnChange,
    Gen_Code_onBlur,
    Gen_Code_Enabled,

    Gen_Location,
    Gen_Location_OnChange,
    Gen_Location_Enabled,
    Gen_TxnDate,
    Gen_TxnDate_OnChange,
    Gen_TxnDate_Enabled,
    Gen_Remark1,
    Gen_Remark1_OnChange,
    Gen_Remark1_Enabled,
    Gen_Remark2,
    Gen_Remark2_OnChange,
    Gen_Remark2_Enabled,

    SearchModelOpen,
    SearchModelTrigger,
    SearchGetSelectRow,
    menuName,
    menuCode,
    LocationCode,
    model_xlarge_sup,
    model_xlarge_loc,
    tox_xlarge_sup,
    tox_xlarge_loc,
    locationOnblur,
    locationDesc,
    GetSelectRowLoc,
    GetSelectRowSup,
    locSearchDisable,
}) => {

    const [mainSearchCol, setmainSearchCol] = useState([])
    const [mainSearchColLoc, setmainSearchColLoc] = useState([])
    const [mainSearchColSup, setmainSearchColSup] = useState([])

    React.useEffect(async () => {
        setmainSearchCol(await loadPopupSearchPay(menuCode, "VOUPO"))
        setmainSearchColLoc(await loadPopupSearchPay(menuCode, "LOCATION"))
        setmainSearchColSup(await loadPopupSearchPay(menuCode, "SUPPLIER"))
    }, [menuCode])


    const [Datatablesub, SetDatatablesub] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')
    //*** End of useStates */
    const ApiURL = window.Links.ApiURL

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">

                                <Row>
                                    <Col>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Document No"
                                            textType="text"
                                            maxLength="25"
                                            value={Gen_Code}
                                            onChange={Gen_Code_OnChange}
                                            disabled={Gen_Code_Enabled}
                                            onBlur={Gen_Code_onBlur}
                                        />
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Button
                                            onClick={Gen_DataSearch}
                                            color="success"
                                            className="btn-sm"
                                            disabled={Gen_Code_Enabled}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                                {/* <Row>
                                     <Col>
                                        <DPTextBoxTow
                                            labelText="Supplier"
                                            disabled1={supSearchDisable ? true : Gen_Supplier_Enabled}
                                            disabled2={true}
                                            value1={Gen_Supplier}
                                            value2={supplierDesc}
                                            onChange1={Gen_Supplier_OnChange}
                                            onBlur1={supplierOnblur}


                                        />
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Button
                                            onClick={tox_xlarge_sup}
                                            color="success"
                                            className="btn-sm"
                                            disabled={supSearchDisable}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>*/}


                                <Row>
                                    <Col>
                                        <DPTextBox
                                            rowClass="mb-2-sm"
                                            labelText="Remarks 1"
                                            textType="text"
                                            maxLength="50"
                                            value={Gen_Remark1}
                                            onChange={Gen_Remark1_OnChange}
                                            disabled={Gen_Remark1_Enabled}
                                        />
                                    </Col><Col sm={12} md={1} className="mb-4-sm"></Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <DPTextBox
                                            rowClass="mb-2-sm"
                                            labelText="Remarks 2"
                                            textType="text"
                                            maxLength="50"
                                            value={Gen_Remark2}
                                            onChange={Gen_Remark2_OnChange}
                                            disabled={Gen_Remark2_Enabled}
                                        />

                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                                </Row>
                            </Col>
                            <Col sm={12} md={6} className="mb-4-sm">
                                <Row>
                                    <Col>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Date"
                                            textType="date"
                                            value={Gen_TxnDate}
                                            onChange={Gen_TxnDate_OnChange}
                                            disabled={Gen_TxnDate_Enabled}
                                        />
                                    </Col><Col sm={12} md={1} className="mb-4-sm"></Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {/* <DPDropDown
                                            rowClass="mb-4-sm"
                                            labelText="Location"
                                            optionGroup={optionLocation}
                                            selectedGroup={Gen_Location}
                                            onChange={Gen_Location_OnChange}
                                            disabled={Gen_Location_Enabled}
                                        /> */}

                                        <DPTextBoxTow
                                            labelText="Location"
                                            disabled1={locSearchDisable ? true : Gen_Location_Enabled}
                                            disabled2={true}
                                            value1={Gen_Location}
                                            value2={locationDesc}
                                            onChange1={Gen_Location_OnChange}
                                            onBlur1={locationOnblur}
                                            onKeyPress1={(e) => {
                                                if (e.key === 'Enter') {
                                                    locationOnblur(e)
                                                }
                                            }}

                                        />

                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Button
                                            onClick={tox_xlarge_loc}
                                            color="success"
                                            className="btn-sm"
                                            disabled={locSearchDisable}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>

                        </Row>

                        <Row>
                            <Col sm={12} md={6} className="mb-3-sm">


                            </Col>
                            <Col sm={12} md={6} className="mb-3-sm">


                            </Col>
                        </Row>

                    </CardText>
                </Col>

                <DPSearchBoxDynamicHeadOffice
                    searchData={Datatablesub}
                    columns={mainSearchCol}
                    defaultSorted={defaultSorted}
                    mainTitle={menuName + " Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={SearchModelOpen}
                    toggle={SearchModelTrigger}
                    getSelect={SearchGetSelectRow}
                    APIURL={ApiURL}
                    URLPath={"VOUREQ"}
                    MenuCode={menuCode}
                    KeyVal={'REQ'}
                    searchBy={'HED_RUNNO'}
                    FilterStr={`AND HED_LOC = ${LocationCode}`}
                />

                <DPSearchBoxDynamic
                    searchData={Datatablesub}
                    columns={mainSearchColSup}
                    defaultSorted={defaultSorted}
                    mainTitle={"Supplier Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={model_xlarge_sup}
                    toggle={tox_xlarge_sup}
                    getSelect={GetSelectRowSup}
                    APIURL={ApiURL}
                    URLPath={"SUPPLIER"}
                    MenuCode={menuCode}
                    KeyVal={'SUP'}
                    searchBy={'SM_CODE'}
                    FilterStr={groupFilter}
                />

                <DPSearchBoxDynamic
                    searchData={Datatablesub}
                    columns={mainSearchColLoc}
                    defaultSorted={defaultSorted}
                    mainTitle={"Location Search"}
                    SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={model_xlarge_loc}
                    toggle={tox_xlarge_loc}
                    getSelect={GetSelectRowLoc}
                    APIURL={ApiURL}
                    URLPath={"LOCATION"}
                    MenuCode={menuCode}
                    KeyVal={'LOC'}
                    searchBy={'LOC_CODE'}
                    FilterStr={groupFilter}
                />

            </div>
        </React.Fragment>
    );
}
export default VoucherRequestContent

